<template>
  <div class="d-flex flex-column h-100">
    <div class="d-flex flex-wrap form-bold-labels">
      <b-col cols="12">
        <div class="d-flex">
          <h5 class="mb-3">Данные по клиенту</h5>
          <div class="ml-auto text-right" v-if="!localEditedItem.company_id && !isAgent && !isClient">
            <b-form-checkbox
              v-model="localEditedItem.short_order"
              name="short_order-check-button"
              :value="1"
              :unchecked-value="0"
              switch
            >
              <b>Заявка без компании</b>
            </b-form-checkbox>
          </div>
        </div>
      </b-col>

      <b-col cols="12" v-if="localEditedItem.short_order">
        <div class="mb-3">
          <label for="temp_name"
            >Условное наименование (метка, компания и т.д.)</label
          >
          <b-form-input
            id="temp_name"
            v-model="localEditedItem.temp_name"
          ></b-form-input>
        </div>
        <div class="mb-3" v-if="localEditedItem.contacts">
          <b-row align-v="center">
            <b-col cols="4">
              <label for="contacts.lead_fio">ФИО контакта</label>
              <b-form-input
                v-model.trim="localEditedItem.contacts.lead_fio"
                type="text"
                class="form-control"
                id="contacts.lead_fio"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label for="contacts.lead_email">E-mail</label>
              <b-form-input
                v-model.trim="localEditedItem.contacts.lead_email"
                type="text"
                class="form-control"
                id="contacts.lead_email"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label for="contacts.lead_phone">Телефон*</label>
              <b-form-input
                v-mask="'+#(###)###-##-##'"
                id="contacts.lead_phone"
                class="form-control"
                type="text"
                v-model="maskPhoneInContacts"
                placeholder="+7(915)067-04-68"
              ></b-form-input>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <b-col cols="12" v-if="!localEditedItem.short_order">
        <div class="mb-3">
          <b-row align-v="end">
            <b-col cols="12" lg="9">
              <label for="company_id">Наименование компании {{ editedItem.company_id }}</label>
              <div v-if="isClient" class="form-control form-control-lg bg-light">
                {{ selectedCompanyNormalized ? selectedCompanyNormalized.name : "Компания не найдена" }}
              </div>
              <tsoft-select-company
                v-else
                :needNullElement="true"
                :selected="localEditedItem.company_id"
                :selectedCompany="selectedCompanyNormalized"
                :hotUpdate="hotCompanyUpdate"
                @set="setCompanyOfOrder"
              ></tsoft-select-company>
            </b-col>
            <b-col cols="3" v-if="!editedItem.company_id && !isClient">
              <b-button
                @click="isSideBarOpenCompany = !isSideBarOpenCompany"
                variant="secondary"
                size="lg"
                id="btn_add_company"
                style="height: 50px;"
              >
                Добавить компанию
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <b-col
        cols="12"
        v-if="localEditedItem.company_id && !editedItemEmployees.loading"
      >
        <div class="mb-3">
          <b-row align-v="center">
            <b-col cols="4">
              <label for="company_employee.lead_fio">ФИО контактного лица в компании</label>
              <b-input-group>
                <b-form-input
                  v-model.trim="localEditedItem.company_employee.lead_fio"
                  type="text"
                  class="form-control"
                  id="company_employee.lead_fio"
                  :readonly="isClient"
                ></b-form-input>
                <template #append v-if="editedItemEmployees.loading">
                  <b-input-group-text>Ищем...</b-input-group-text>
                </template>
                <template #append v-if="!editedItemEmployees.loading">
                  <b-button
                    v-if="!isClient && localEditedItem.company_employee_id"
                    variant="outline-danger"
                    @click="clearEmployee()"
                  >
                    <b-icon icon="x" />
                  </b-button>
                  <b-dropdown
                    v-if="
                      !isClient &&
                      !localEditedItem.company_employee_id &&
                      editedItemEmployees.employees.length > 0
                    "
                    toggle-class="h-100"
                    text="Выбрать"
                    variant="success"
                  >
                    <b-dropdown-item-button
                      v-for="(employee, index) in editedItemEmployees.employees"
                      :key="employee.id"
                      @click="setEmployee(index)"
                    >
                      {{ employee.lead_fio }} :
                      {{ employee.lead_phone | VMask("+#(###)###-##-##") }}
                    </b-dropdown-item-button>
                  </b-dropdown>
                </template>
              </b-input-group>
            </b-col>
            <b-col cols="4">
              <label for="company_employee.lead_email">E-mail</label>
              <b-form-input
                v-model.trim="localEditedItem.company_employee.lead_email"
                type="text"
                class="form-control"
                id="company_employee.lead_email"
                :readonly="isClient"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label for="company_employee.lead_phone">Телефон*</label>
              <b-form-input
                v-mask="'+#(###)###-##-##'"
                id="company_employee.lead_phone"
                class="form-control"
                type="text"
                v-model="maskPhone"
                placeholder="+7(915)067-04-68"
                :readonly="isClient"
              ></b-form-input>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <b-col cols="12 mt-3">
        <div class="d-flex flex-wrap">
          <h5 class="mb-3 mr-auto">Основные данные</h5>
          <template v-if="!isAgent && !isClient">
            <b-form-checkbox
                v-model="localEditedItem.outsourcing_order"
                name="outsourcing_order-check-button"
                switch
                :value="1"
                :unchecked-value="0"
                class="mr-3"
            >
                <b>Аутсорсинговая поставка</b>
            </b-form-checkbox>
            <b-form-checkbox
                v-model="needOptionalSalesManager"
                name="optional-sales-manager-check-button"
                switch
            >
                <b>Назначить Sales менеджера на заказ</b>
            </b-form-checkbox>
          </template>
        </div>
      </b-col>

      <b-col cols="12" lg="6">
        <div class="mb-3" v-if="!isClient">
          <label>Категория</label>
          <tsoft-select-of-properties
            :reference_id="2"
            :needNullElement="false"
            :needMultipleSelect="true"
            :defaultSelectName="`Выберите нужные варианты`"
            :selectedArray="localEditedItem.set_categories_ids"
            @set="setCategoriesOfOrder"
          ></tsoft-select-of-properties>
        </div>

        <div class="mb-3">
          <label>Вид услуги</label>
          <tsoft-select-of-properties
            :reference_parent_id="21"
            :needNullElement="false"
            :needMultipleSelect="true"
            :defaultSelectName="`Выберите нужные варианты`"
            :selectedArray="localEditedItem.set_services_ids"
            :excludeArray="isAgent ? [66, 75] : [66]"
            :disabled="localEditedItem.reference_status_id == 541 && isAgent"
            @set="setServicesOfOrder"
          ></tsoft-select-of-properties>
        </div>

        <div class="mb-3" v-if="!isClient">
          <label for="receive_datetime">Дата получения заявки</label>
          <b-form-input
            id="receive_datetime"
            type="datetime-local"
            v-model="localEditedItem.receive_datetime"
          ></b-form-input>
        </div>

        <div class="mb-3" v-if="!isClient">
          <label
            for="processing_end_datetime"
            title="КП направлено/консультация оказана"
            >Дата отработки заявки</label
          >
          <b-form-input
            id="processing_end_datetime"
            :type="`datetime-local`"
            v-model="localEditedItem.processing_end_datetime"
          ></b-form-input>
        </div>
      </b-col>

      <b-col cols="12" lg="6">
        <template v-if="!isAgent && !isClient">
            <div v-if="needOptionalSalesManager" class="mb-3">
                <label>Менеджер SALES</label>
                <tsoft-select-user
                  id="optional_sales_manager_user_id"
                  :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager||agent`"
                  :needNullElement="true"
                  :selected="localEditedItem.optional_sales_manager_user_id"
                  @set="setSalesManagerOfOrder"
                ></tsoft-select-user>
            </div>
            <div class="mb-3">
                <label>Источник поставки</label>
                <tsoft-select-of-properties
                  id="reference_sources_id"
                  :reference_id="4"
                  :needNullElement="false"
                  :defaultSelectName="`Выберите нужные варианты`"
                  :selected="localEditedItem.reference_sources_id"
                  :excludeArray="isSalesManagerAccount ? [24,25,26,27,28,29,30,31,32,33,34,36,320,375,392,410,415,418,446,447,893,948,949,950,951,956,957,960,961,1002,1039,1044] : [
                    25,26,27,28,29,30,31,32,33,34,35,36,320,375,392,415,418,446,447,537
                  ]"
                  @set="setSourcesOfOrder"
                ></tsoft-select-of-properties>
                <!-- 446, 319, 447, 415, 392, 418, 320, 35, 375, 30, 33, 28, 410, 29, 27, 32, 31, 25, 24, 26, 36, 34, 893 -->
            </div>      
        </template>

        <div class="mb-3">
          <label for="comment">Комментарий к заявке</label>
          <b-form-textarea
            id="textarea-comment"
            placeholder="Оставьте комментарий к заявке, если есть что сообщить..."
            :rows="(isAgent || isClient) ? 10:5"
            max-rows="12"
            v-model="localEditedItem.comment"
          ></b-form-textarea>
        </div>

        <div class="mb-3" v-if="!isAgent && !isClient">
          <label
            for="predictable_mp"
            title="Предполагаемая маржинальная прибыль в рублях"
            >Предполагаемая МП, руб.</label
          >
          <b-form-input
              id="predictable_mp"
              v-model.trim="localEditedItem.predictable_mp"
              type="text"
              @keyup="changeCommasOnDots($event)"
              style="max-width: 300px"
          ></b-form-input>
        </div>
      </b-col>
    </div>

    <InstructionText 
      v-if="isAgent"
      userType="agent" 
      section="order-create"
      :contextData="localEditedItem"
    />

    <div v-if="isClient" class="mb-3 px-3">
      <div class="border rounded p-3 bg-light">
        <tsoft-create-documents
          ref="clientDocumentUploader"
          :orderId="pendingDocumentOrderId"
          :companyId="pendingDocumentCompanyId"
          :needUploadButton="false"
          :onlyMultiUploadDocuments="true"
          :onlySmallScreenMultiUpload="true"
        />
        <small class="text-muted d-block mt-2">
          Документы необязательны. Их можно прикрепить сейчас - они появятся в заявке.
        </small>
      </div>
    </div>

    <div class="sticky-save-block mt-auto p-3">
      <div class="d-flex">
        <slot name="footer" />
      </div>
    </div>

    <tsoft-create-company
      :isSideBarOpenCompany.sync="isSideBarOpenCompany"
      :editedItem="{}"
      @create="setCreatedCompany"
      @closeSidePanel="setClosedSidePanelCompany"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { API_EMPLOYEES } from "../../constants";
import {
    changeCommasOnDots
} from '../../mixins'
import tsoftCreateCompany from "@components/companies/CreatedOrEditedCompany";
import InstructionText from "@components/common/InstructionText";

export default {
  props: {
    editedItem: {
      type: Object,
      default: () => ({
        id: "",
        text_mark: null,
        bitrix_deal_id: null,        
        creator_user_id: "",
        creator: {},
        company_employee_id: "",
        company_employee: {
          id: "",
          lead_fio: "",
          lead_email: "",
          lead_phone: "",
        },
        reference_order_type_id: 1,
        type: {},
        company_id: "",
        company: {},
        temp_name: "",
        contacts: {
          lead_fio: "",
          lead_email: "",
          lead_phone: "",
        },
        client: {},
        set_categories_ids: [], // Virtual for setting up categories
        categories: [],
        set_services_ids: [], // Virtual for setting up services
        services: [],
        reference_status_id: 359,
        status: {},
        receive_datetime: null,
        processing_end_datetime: null,
        comment: "",
        reference_close_reason_id: "",
        close_reason: {},
        close_comment: "",
        documents: [],
        short_order: false,
        optional_sales_manager_user_id: "",
        optional_sales_manager: {},
        agent_company_id: "",
        agent_company: {},
        outsourcing_order: 0,
        outsourcing_type_name: 'Нет',
        reference_sources_id: "",
        predictable_mp: null,
        related_orders: []
      }),
    },
  },
  components: {
    "tsoft-create-company": tsoftCreateCompany,
    InstructionText,
  },
  mixins: [
    changeCommasOnDots,
  ],
  data() {
    return {
      localEditedItem: JSON.parse(JSON.stringify(this.editedItem)),
      maskPhone: "",
      maskPhoneInContacts: "",
      needOptionalSalesManager: false,
      isSideBarOpenCompany: false,
      hotCompanyUpdate: false,
      editedItemEmployees: {
        employees: [],
        loading: true,
        addNew: false,
      },
      pendingDocumentOrderId: "",
      pendingDocumentCompanyId: "",
      outsourcingOrderStatus: false
    };
  },

  watch: {
    maskPhone: function (phone) {
      if (phone) {
        let freshPhone = phone.replace(/[^0-9]/g, "");
        this.localEditedItem.company_employee.lead_phone = freshPhone;
      }
    },
    maskPhoneInContacts: function (phone) {
      if (phone) {
        let freshPhone = phone.replace(/[^0-9]/g, "");
        this.localEditedItem.contacts.lead_phone = freshPhone;
      }
    },

    localEditedItem: {
      handler(value) {
        this.$emit("change-order", value);
      },
      deep: true,
    },

    needOptionalSalesManager: function (value) {
      if (!value) {
        this.localEditedItem.optional_sales_manager_user_id = "";
      }
    },

    "localEditedItem.receive_datetime": {
      handler(value) {
        this.localEditedItem.receive_datetime = value
          ? this.$moment(value).format("YYYY-MM-DDTHH:mm")
          : null;
      },
      immediate: true,
    },

    "localEditedItem.processing_end_datetime": {
      handler(value) {
        this.localEditedItem.processing_end_datetime = value
          ? this.$moment(value).format("YYYY-MM-DDTHH:mm")
          : null;
      },
      immediate: true,
    },
    "localEditedItem.company_id": function (value, oldValue) {
      this.loadCompanyEmployees(value);
      // Clear employee data when company changes
      if (value !== oldValue && oldValue !== undefined) {
        this.clearEmployee();
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["currentUser", "isAuthenticated"]),

    isAgent() {
        return this.currentUser.role.includes("agent");
    },

    isClient() {
        return this.currentUser.role.includes("client");
    },

    agentCompany() {
        if (this.isAgent) {
            return this.$store.getters['auth/getAgentCompany'];
        }
        
        return null;
    },

    isSalesManagerAccount() {
        return this.currentUser.role.includes("sales-manager") || this.currentUser.role.includes("sales-head-manager");
    }, 

    // Normalize selected company shape for multiselect
    selectedCompanyNormalized() {
      const company = this.localEditedItem && this.localEditedItem.company ? this.localEditedItem.company : null;
      if (company && typeof company === 'object') {
        const id = company.id || this.localEditedItem.company_id || null;
        const name = company.name || company.short_name || company.legal_name || company.temp_name || '';
        const inn = company.inn || company.inn_kpp || '';
        if (id && name) {
          return { id, name, inn };
        }
      }
      return null;
    }
  },
  mounted() {
    // Always load company employees if company_id is set, regardless of whether employee is already selected
    if (this.localEditedItem.company_id) {
      this.loadCompanyEmployees(this.localEditedItem.company_id);
    }
    
    // Initialize company_employee object if not already set
    if (!this.localEditedItem.company_employee_id) {
      this.localEditedItem.company_employee = Object.assign(
        {},
        this.localEditedItem.company_employee,
        {
          id: "",
          lead_fio: "",
          lead_email: "",
          lead_phone: "",
        }
      );
    } else {
      // Ensure company_employee object exists even if employee is already selected
      if (!this.localEditedItem.company_employee) {
        this.localEditedItem.company_employee = {
          id: "",
          lead_fio: "",
          lead_email: "",
          lead_phone: "",
        };
      }
    }
    if (!this.localEditedItem.contacts) {
      this.localEditedItem.contacts = {
        lead_fio: "",
        lead_email: "",
        lead_phone: "",
      }
    }
    this.maskPhoneInContacts = this.localEditedItem.contacts.lead_phone ? this.localEditedItem.contacts.lead_phone : '';
    
    // Initialize phone mask for company employee if exists
    if (this.localEditedItem.company_employee && this.localEditedItem.company_employee.lead_phone) {
      this.maskPhone = this.localEditedItem.company_employee.lead_phone;
    }

    if (this.localEditedItem.optional_sales_manager_user_id && this.localEditedItem.optional_sales_manager_user_id !== "") {
      this.needOptionalSalesManager = true;
    }

    this.agentPropsInit();

    // Ensure company object shape matches multiselect expectations
    if (!this.localEditedItem.company || typeof this.localEditedItem.company !== 'object') {
      this.localEditedItem.company = {};
    }
  },
  methods: {
    uploadPendingDocuments(orderId, companyId) {
      var self = this;
      return new Promise(function (resolve) {
        if (!self.isClient || !self.$refs.clientDocumentUploader) {
          resolve();
          return;
        }

        var uploader = self.$refs.clientDocumentUploader;
        var hasMulti =
          uploader.multipleFiles && uploader.multipleFiles.length > 0;
        var hasSingle = !!uploader.areAnyFilesHere;

        if (!hasMulti && !hasSingle) {
          resolve();
          return;
        }

        self.pendingDocumentOrderId = Number(orderId);
        self.pendingDocumentCompanyId = Number(companyId || self.localEditedItem.company_id);

        self.$nextTick(function () {
          var finished = false;
          var onDone = function () {
            if (finished) {
              return;
            }
            finished = true;
            uploader.$off("onFileOperationCompleted", onDone);
            resolve();
          };

          uploader.$on("onFileOperationCompleted", onDone);
          uploader.loadingDocuments();

          // На случай пустого ответа/ошибки сети не зависаем в сохранении.
          setTimeout(onDone, 15000);
        });
      });
    },
    agentPropsInit() {
        if (this.isAgent && this.editIndex === -1) {
            this.setSalesManagerOfOrder(this.currentUser.id);
            this.setSourcesOfOrder(1044);   // Agent

            if (this.agentCompany && this.agentCompany.id) {
                this.setAgentCompanyOfOrder(this.agentCompany.id);
            }
        }
    },
    setCompanyOfOrder(value) {
      this.localEditedItem.company_id = value;
    },
    setAgentCompanyOfOrder(value) {
      this.localEditedItem.agent_company_id = value;
    },
    setCategoriesOfOrder(value) {
      this.localEditedItem.set_categories_ids = value;
    },
    setServicesOfOrder(value) {
      this.localEditedItem.set_services_ids = value;
    },
    setSourcesOfOrder(value) {
      this.localEditedItem.reference_sources_id = value;
    },
    setSalesManagerOfOrder(value) {
      this.localEditedItem.optional_sales_manager_user_id = value;
    },
    setCreatedCompany(data) {
      this.localEditedItem.company_id = data.id;
      this.localEditedItem.company = data;
      this.hotCompanyUpdate = !this.hotCompanyUpdate;

      this.isSideBarOpenCompany = false;
    },
    setClosedSidePanelCompany() {
      this.editedItemEmployees.employees = [];
    },
    loadCompanyEmployees(company_id) {
      this.editedItemEmployees.loading = true;
      if (this.isClient) {
        this.editedItemEmployees.employees = [];
        this.editedItemEmployees.loading = false;
        return;
      }
      if (company_id) {
        axios
          .get(`${API_EMPLOYEES}/?company_id=${company_id}`)
          .then(({ data }) => {
            this.editedItemEmployees.employees = data.data;
          })
          .finally(() => {
            this.editedItemEmployees.loading = false;
          });
      } else {
        this.editedItemEmployees.employees = [];
        this.editedItemEmployees.loading = false;
      }
    },
    setEmployee(index) {
      this.localEditedItem.company_employee_id =
        this.editedItemEmployees.employees[index].id;
      this.localEditedItem.company_employee.id =
        this.editedItemEmployees.employees[index].id;
      this.localEditedItem.company_employee.lead_fio =
        this.editedItemEmployees.employees[index].lead_fio;
      this.maskPhone = this.editedItemEmployees.employees[index].lead_phone;
      this.localEditedItem.company_employee.lead_email =
        this.editedItemEmployees.employees[index].lead_email;
    },
    clearEmployee() {
      this.maskPhone = "";
      this.localEditedItem.company_employee_id = "";
      this.localEditedItem.company_employee.lead_fio = "";
      this.localEditedItem.company_employee.lead_phone = "";
      this.localEditedItem.company_employee.lead_email = "";
    },
  },
};
</script>

<style scoped>
  .sticky-save-block {
    position: sticky;
    bottom: 0;
    right: 0;
    text-align: right;
    width: 100%;
    background: #dbdbdba6;
  }
  .custom-select {
    line-height: 32px;
    height: 50px;
    border-radius: 1px;
  }
</style>
